import styled from "styled-components";

import arrow from "../../images/icons/arrow-right.svg";

export const TextImageTalentsWrapper = styled.section`
  max-width: 1184px;
  margin: 0 auto 140px;
  padding: 0 48px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
    margin-bottom: 64px;
    padding: 0 24px;
  }
`;

export const Title = styled.h2`
  font-size: 36px;
  margin-bottom: 24px;
  font-weight: 800;

  @media (max-width: 768px) {
    font-size: 28px;
    margin-bottom: 24px;
  }
`;

export const P = styled.p`
  font-size: 16px;
  line-height: 28px;
`;

export const P2 = styled(P)`
  margin-top: 16px;

  span {
    font-style: italic;
  }
`;

export const BoxText = styled.div`
  min-width: 330px;
  max-width: 448px;

  @media (max-width: 768px) {
    min-width: 100%;
    margin-left: 0;
  }
`;

// IMAGE LEFT WRAPPER DESKTOP
export const BoxImage = styled.div`
  width: 100%;
  max-width: 528px;
  margin-left: 32px;

  @media (max-width: 768px) {
    display: none;
  }
`;

// IMAGE WRAPPER MOBILE
export const BoxImageMobile = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: block;
    width: 100%;
    margin: 0 auto 32px;
  }
`;

export const SmallLink = styled.a`
  display: inline-block;
  font-size: 16px;
  line-height: 1.75;
  color: var(--orange);
  text-decoration: none;
  position: relative;
  border-bottom: 1px solid #fff;

  transition: all 0.2s;
  margin-top: 24px;
  padding: 3px 0;

  :hover {
    text-decoration: none;
    border-color: var(--orange);
  }

  ::after {
    content: url(${arrow});
    display: inline-block;
    position: absolute;
    top: 5px;
    margin-left: 4px;
    transition: all 0.2s;
  }

  @media (max-width: 768px) {
    margin-top: 16px;
  }

  @media (min-width: 768px) {
    :hover::after {
      transform: translateX(4px);
    }
  }
`;
